import config from "../../config/config";
import api from "../../instance/JsonInstance";

export const authAPI = {
  login: (credentials) =>
    api.post(`${config.backendUrl}/auth/login`, credentials),
};

export const teamMember = {
  createTeamMember: (formData) =>
    api.post(`${config.backendUrl}/team-member/create_teamMember`, formData),

  getAllTeamMembers: (params = {}) =>
    api.get(`${config.backendUrl}/team-member/get-all-teamMembers`, { params }),

  deleteTeamMembers: (id) =>
    api.delete(`${config.backendUrl}/team-member/delete-teamMember/${id}`),

  undoDeleteTeamMembers: (id) =>
    api.patch(`${config.backendUrl}/team-member/undo-delete-teamMember/${id}`),

  updateTeamMembers: (id, data) =>
    api.put(`${config.backendUrl}/team-member/update-teamMember/${id}`, data),

  updateTeamMemberOrder: (newOrder) =>
    api.put(`${config.backendUrl}/team-member/update-order`, {
      newOrder,
    }),
};

export const OrganCategory = {
  createOrganCategory: (formData) =>
    api.post(
      `${config.backendUrl}/organcategory/create_organCategory`,
      formData
    ),
  getAllOrganCategories: (params = {}) =>
    api.get(`${config.backendUrl}/organcategory/get-all-organCategories`, {
      params,
    }),
  deleteOrganCategory: (id) =>
    api.delete(`${config.backendUrl}/organcategory/delete-organCategory/${id}`),
  undoDeleteOrganCategory: (id) =>
    api.patch(
      `${config.backendUrl}/organcategory/undo-delete-organCategory/${id}`
    ),
  updateOrganCategory: (id, data) =>
    api.put(
      `${config.backendUrl}/organcategory/update-organCategory/${id}`,
      data
    ),
};

export const DonorReview = {
  createDonorReview: (formData) =>
    api.post(`${config.backendUrl}/donorReview/create_donorReview`, formData),
  getAllDonorReviews: (params = {}) =>
    api.get(`${config.backendUrl}/donorReview/get-all-donorReviews`, {
      params,
    }),
  deleteDonorReview: (id) =>
    api.delete(`${config.backendUrl}/donorReview/delete-donorReview/${id}`),
  undoDeleteDonorReview: (id) =>
    api.patch(`${config.backendUrl}/donorReview/undo-delete-donorReview/${id}`),
  updateDonorReview: (id, data) =>
    api.put(`${config.backendUrl}/donorReview/update-donorReview/${id}`, data),
};

export const Blogs = {
  createBlog: (formData) =>
    api.post(`${config.backendUrl}/blogs/create-blogs`, formData),
  getAllBlogs: (params = {}) =>
    api.get(`${config.backendUrl}/blogs/get-all-blogs`, {
      params,
    }),
  deleteBlog: (id) =>
    api.delete(`${config.backendUrl}/blogs/delete-blog/${id}`),
  undoDeleteBlog: (id) =>
    api.patch(`${config.backendUrl}/blogs/undo-delete-blog/${id}`),
  updateBlog: (id, data) =>
    api.put(`${config.backendUrl}/blogs/update-blog/${id}`, data),
};

export const EventCategory = {
  createEventCategory: (formData) =>
    api.post(
      `${config.backendUrl}/eventcategory/create-eventCategory`,
      formData
    ),
  getAllEventCategories: (params = {}) =>
    api.get(`${config.backendUrl}/eventcategory/get-all-eventCategories`, {
      params,
    }),
  deleteEventCategory: (id) =>
    api.delete(`${config.backendUrl}/eventcategory/delete-eventCategory/${id}`),
  undoDeleteEventCategory: (id) =>
    api.patch(
      `${config.backendUrl}/eventcategory/undo-delete_eventCategory/${id}`
    ),
  updateEventCategory: (id, data) =>
    api.put(
      `${config.backendUrl}/eventcategory/update-eventCategory/${id}`,
      data
    ),
};

export const PressCategory = {
  createPressCategory: (formData) =>
    api.post(
      `${config.backendUrl}/presscategory/create-pressCategory`,
      formData
    ),
  getAllPressCategories: (params = {}) =>
    api.get(`${config.backendUrl}/presscategory/get-all-pressCategories`, {
      params,
    }),
  deletePressCategory: (id) =>
    api.delete(`${config.backendUrl}/presscategory/delete-pressCategory/${id}`),
  undoDeletePressCategory: (id) =>
    api.patch(
      `${config.backendUrl}/presscategory/undo-delete_pressCategory/${id}`
    ),
  updatePressCategory: (id, data) =>
    api.put(
      `${config.backendUrl}/presscategory/update-pressCategory/${id}`,
      data
    ),
};

export const DataCount = {
  dataCount: () => api.get(`${config.backendUrl}/dashboard/dashboard-counts`),
};

export const PhotoGallery = {
  getAllPhotos: (params = {}) =>
    api.get(`${config.backendUrl}/photogallery/get-all-photos`, { params }),

  getPhotosByCategory: (params = {}) =>
    api.get(`${config.backendUrl}/photogallery/get-photos-by-category`, { params }),

  createPhoto: (formData) =>
    api.post(`${config.backendUrl}/photogallery/upload-photo`, formData),

  updatePhoto: (id, formData) =>
    api.put(`${config.backendUrl}/photogallery/update-photo/${id}`, formData),

  deletePhoto: (id) =>
    api.delete(`${config.backendUrl}/photogallery/delete-photo/${id}`),

  undoDeletePhoto: (id) =>
    api.patch(`${config.backendUrl}/photogallery/undo-delete-photo/${id}`),
};

export const videoSection = {
  createVideo: (formData) =>
    api.post(`${config.backendUrl}/videosection/create-video`, formData),

  getAllVideos: (params = {}) =>
    api.get(`${config.backendUrl}/videosection/get-all-videos`, { params }),

  deleteVideos: (id) =>
    api.delete(`${config.backendUrl}/videosection/delete-video/${id}`),

  undoDeleteVideos: (id) =>
    api.patch(`${config.backendUrl}/videosection/undo-delete_video/${id}`),

  updateVideos: (id, data) =>
    api.put(`${config.backendUrl}/videosection/update-video/${id}`, data),
};

export const electricMedia = {
  createElectricMedia: (formData) =>
    api.post(`${config.backendUrl}/electronicmedia/create-electric-media`, formData),

  getAllElectricMedia: (params = {}) =>
    api.get(`${config.backendUrl}/electronicmedia/get-all-electronic-media`, { params }),

  deleteElectricMedia: (id) =>
    api.delete(`${config.backendUrl}/electronicmedia/delete-electric-media/${id}`),

  undoDeleteElectricMedia: (id) =>
    api.patch(`${config.backendUrl}/electronicmedia/undo-delete-electric-media/${id}`),

  updateElectricMedia: (id, data) =>
    api.put(`${config.backendUrl}/electronicmedia/update-electric-media/${id}`, data),
};

export const digitalMedia = {
  createDigitalMedia: (formData) =>
    api.post(`${config.backendUrl}/digitalmedia/create-digital-media`, formData),

  getAllDigitalMedia: (params = {}) =>
    api.get(`${config.backendUrl}/digitalmedia/get-all-digital-media`, { params }),

  deleteDigitalMedia: (id) =>
    api.delete(`${config.backendUrl}/digitalmedia/delete-digital-media/${id}`),

  undoDeleteDigitalMedia: (id) =>
    api.patch(`${config.backendUrl}/digitalmedia/undo-delete-digital-media/${id}`),

  updateDigitalMedia: (id, data) =>
    api.put(`${config.backendUrl}/digitalmedia/update-digital-media/${id}`, data),
};

export const donorApplication = {
  approveDonorApplication: (id, data) =>
    api.patch(`${config.backendUrl}/donorApplication/approve-donorApplication/${id}`, data),

  getAllDonorApplications: (params = {}) =>
    api.get(`${config.backendUrl}/donorApplication/get-all-donorApplications`, { params }),

  getDonorApplicationById: (id) =>
    api.get(`${config.backendUrl}/donorApplication/get-donor-application/${id}`),

  updateDonorApplication: (id, data) =>
    api.put(`${config.backendUrl}/donorApplication/update-donorApplication/${id}`, data),

  rejectDonorApplication: (id, data) =>
    api.patch(`${config.backendUrl}/donorApplication/reject-donorApplication/${id}`, data),
};

export const payment = {
  getPayment: (params = {}) =>
    api.get(`${config.backendUrl}/payment/get-payment`, { params }),

};